import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useFont } from "../contexts/FontContext";
import Page from "../Components/Page";
import HomeButton from "../Components/HomeButton";

const FAQ = () => {
  const fontValue = useFont();
  const font = fontValue?.font;

  const [, setError] = useState(null);
  const [faqData, setFaqData] = useState(null);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_STRAPI_API_URL + "/api/faq?populate=*")
      .then(({ data }) => {
        setFaqData(data.data);
      })
      .catch((error) => setError(error));
  }, []);

  return (
    <Page isLoading={fontValue?.loading}>
      <div className="bg-gray-300 ">
        <div className="lg:max-w-[1100px] m-auto ">
          <div className="flex justify-center pt-10">
            <p className={`${font?.SUHTX} text-black text-center`}>
              {faqData?.attributes?.FAQHTX_1}
            </p>
          </div>

          <div className="flex justify-center pt-3 pb-5">
            <div className="lg:max-w-[1100px] m-auto  lg:py-6 py-2  lg:pt-2 ">
              <div className=" justify-start pt-2 pb-5">
                <div id="display-lawmafaqai"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HomeButton />
    </Page>
  );
};

export default FAQ;
